import React, { useState } from 'react';
import Modal from '../components/Modal/Modal';
import AddEntity from '../components/AddEntity/AddEntity';
import ApiManager from '../ApiManager/ApiManager';

const CarTypeFields = [
    { label: 'Vehicle Type', name: 'name', type: 'text', required: true},
    { label: 'Description', name: 'description', type: 'text', required: true},
    { label: 'Fuel Capacity (CNG) in Liters', name: 'fuel_capacity_cng', type: 'number', required: true},
    { label: 'Max KM in Full CNG', name: 'max_km_in_full_cng', type: 'number', required: true}
];


const NewCarType = ({onSuccess}) => {
    const [isModalOpen, setModalOpen] = useState(false);

    const toggleModal = () => {
        setModalOpen(!isModalOpen);
    };

    return (
        <div>
                <button className="custom-button" onClick={toggleModal}>
                    New Car Type
                </button>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                <AddEntity 
                    toggleFunction={toggleModal}
                    title="Add Car Type" 
                    formFields={CarTypeFields}
                    apiFunction={ApiManager.addCarType}
                    onSuccess={onSuccess}
                />
            </Modal>
        </div>
    );
};

export default NewCarType;
